export default function CitizenReporter () {
    return (
    <div>
  <div className="citizenreporter-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Citizen Reporter</h2>
</div>


{/* End Large Image Space */}


{/* Start Main Content */}
<div className="content-fluid">

    <div className="mb-960-center-container mid-side-outlines mobile-pad-1em">
        {/* Full Width Element */}
        <div className="mb-960-col-50p">
            <p>
                The Citizen Reporter allows residents to make requests for service and report community issues. Users have the option to upload a photo with each service request to help communicate the issue. Requests will be sent to a Borough staff member who will address the issue.
            </p>
            <p>
                Updates will be provided when possible. Issues will be addressed during normal Borough business hours, with most requests being resolved within one or two business days. If a report comes in on a holiday, weekend, or after hours, it will be addressed the next business day.
            </p>
            <p>
                Please note that issues pertaining to federal, state or bridge commission property should be directed to those entities and not to Morrisville Borough.
            </p>
        </div>
        <div className="mb-960-col-50p">

            <div className="top-buttons mb-shadow-text">
                {/* <a href="https://traisr.net/mvbreporter" className="button button-1"><i className="fa-solid fa-screwdriver-wrench fa-lg"></i>&nbsp;CLICK HERE TO LAUNCH CITIZEN REPORTER</a> */}
                <a href="https://morrisvilleboro.maps.arcgis.com/apps/instant/reporter/index.html?appid=50a077aa0a3e4ade8e3f7d1072ac996c" className="button button-1"><i className="fa-solid fa-screwdriver-wrench fa-lg"></i>&nbsp;CLICK HERE TO LAUNCH CITIZEN REPORTER</a>
            </div>
            <img className="img-width100" src="./img/citizen-reporter-sample.png" alt="Sample of the Citizen Report Standard Screen"/>

        </div>
    </div>
</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>

</div>
            </div>
            )
            }
